.bordered {
    display: flex !important;
    flex-direction: column !important;
    max-width: 480px;
    height: auto;
    position: relative;
    margin: 0px auto;
    box-shadow: rgba(0, 0, 0, 0.06) 0px -0.0525rem 0.1875rem,
        rgba(0, 0, 0, 0.05) 0px 0.0625rem 0.1875rem,
        rgba(0, 0, 0, 0.05) 0px 0.625rem 0.9375rem -0.3125rem,
        rgba(0, 0, 0, 0.04) 0px 0.4375rem 0.4375rem;
    border-radius: 5px;
}

.fillHeight {
    height: 100%;
}
